import { Box } from "@mui/material";
import { ParagraphText } from "../../../../Libraries";
import imagePlaceholder from "../../../../assets/images/imagePlaceholder.png";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./TransactionListing.module.css";

const CompanyRow = ({ item, onViewBills }) => {
  const {
    bill_company,
    billing_company,
    logo_link,
    consumer_number_masked,
    consumer_number,
    consumer_name,
  } = item || {};

  const companyName = bill_company || billing_company || "-";
  const consumerNum = consumer_number_masked || consumer_number || "-";

  return (
    <Box
      id={`transaction_listing_company_row_${consumerNum}`}
      className="invoiceListTableBody accountTableHeaderMain pointer"
      onClick={() => {
        triggerLogEvent(analytics, "w_bill_txn_view_bills");
        onViewBills?.(item);
      }}
    >
      <Box className={`invListTableHeaderCol fourColumn textLeft ${styles.contactCell}`}>
        <img
          src={logo_link || imagePlaceholder}
          alt={companyName}
          className={styles.companyLogo}
          onError={(e) => { e.target.src = imagePlaceholder; }}
        />
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine newFontColor">
          {companyName}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {consumerNum}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {consumer_name || "-"}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn justifyCenter">
        <ParagraphText className={styles.viewDetailBtn}>
          View details 
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default CompanyRow;
